import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { TrustedBy } from '../components/TrustedBy';
import { WhySmartConnections } from '../components/WhySmartConnections';
import { StepByStep } from '../components/StepByStep';
import { HowItWorks } from '../components/HowItWorks';
import { Stats } from '../components/Stats';
import { PlatformFeatures } from '../components/PlatformFeatures';
import { ReviewCards } from '../components/ReviewCards';
import { About } from '../components/About';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { AuthModal } from '../components/auth/AuthModal';

export default function HomePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    // Check if showAuth query parameter is present
    if (searchParams.get('showAuth') === 'true') {
      setShowAuthModal(true);
      // Remove the query parameter from URL
      searchParams.delete('showAuth');
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    
    // Check if there was an intended card ID stored
    const intendedCardId = sessionStorage.getItem('intended_card_id');
    if (intendedCardId) {
      sessionStorage.removeItem('intended_card_id');
      navigate(`/customize-card/${intendedCardId}`);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <WhySmartConnections />
        <StepByStep />
        <Stats />
        {/* COMMENTED OUT - PlatformFeatures - Will be used later for digital cards */}
        {/* <PlatformFeatures /> */}
        <HowItWorks />
        <ReviewCards />
        <About />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      
      {/* Auth Modal */}
      <AuthModal 
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onSuccess={handleAuthSuccess}
      />
    </div>
  );
}
